<template>
<div class="panel" id="ranking-panel">
    <div class="panel-title">
        {{activatedClub.leagues[0].name}}
        <hr>
    </div>
    <div v-if="activatedClub" class="panel-content">
        <rankingGroupPanel v-for="rg in activatedClub.leagues[0].ranking_groups"
                           :key="activatedClub.leagues[0].ranking_groups"
                           :rankingGroup="rg">
        </rankingGroupPanel>
        <div class="row columns">
            <router-link :to="{ name:'rankingGeneral'}" class="bottom-link" >Voir le classement détaillé...</router-link>
        </div>
    </div>
    <div v-else>
        <spinner></spinner>
    </div>
</div>
</template>

<script>
import spinner from '../common/spinner.vue'
import { mapGetters } from 'vuex'
import store from '../../store/index.js'
import rankingGroupPanel from './ranking-group-panel.vue'

export default {
  name: 'rankingPanel',
  components: {
    spinner,
    rankingGroupPanel
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'ranking',
      'activatedClub'
    ])
  },
  methods: {
  },
  created () {
    store.dispatch('getRanking')
    store.dispatch('getWeekList')
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ranking{
    font-weight: 300;
}

div.ranking-line div{
    margin:0;
    padding:0;
}

.trend-icon-up {
    color: #009900;
    -ms-transform: rotate(-45deg); /* IE 9 */
    -webkit-transform: rotate(-45deg); /* Chrome, Safari, Opera */
    transform: rotate(45deg);
}

.trend-icon-down {
    color: #CC0000;
    -ms-transform: rotate(-135deg); /* IE 9 */
    -webkit-transform: rotate(-135deg); /* Chrome, Safari, Opera */
    transform: rotate(45deg);
}

.trend-icon-neutral {
    color: #BBBBBB;
    -ms-transform: rotate(-90deg); /* IE 9 */
    -webkit-transform: rotate(-90deg); /* Chrome, Safari, Opera */
    transform: rotate(45deg);
}

.small-team-icon {
    width: 25px;
    height: 25px;
}

.ranking tr td{
    padding: 0.5rem 0rem;
    font-size: 0.8em;
}

.ranking tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.ranking tr:nth-of-type(even) {
    transition: background-color 0.15s;
    background-color: #ffffff;
}

.ranking td:nth-of-type(5n) {
    font-weight: 400;
}

.ranking tr:hover{
    background-color: #ACB5C3;
    cursor: pointer;
}
.ranking tr:hover td:nth-of-type(5n){
    background-color: #ACB5C3;
    cursor: pointer;
}


.ranking tr td{
    text-align: center;
}

.ranking tr td img{
    width: 25px;
    height: 25px;
}

.ranking td:nth-of-type(1) {
    padding: 0rem 0.5rem
}

.ranking td:nth-of-type(5) {
    padding: 0rem 0.3rem
}

.win {
    border-left-style: solid;
    border-left-width: 4px;
    border-left-color: #009900;
}

.lose {
    border-left-style: solid;
    border-left-width: 4px;
    border-left-color: #CC0000;
}
</style>



// WEBPACK FOOTER //
// ranking-panel.vue?ba13d8b6